import React, { useState, useEffect, FC } from 'react';
import ComparePlansRowStyled from './ComparePlansRowStyled';
import { Check, Minus } from '~/components/Icons/fill';
import Tooltip from '~/components/Tooltip';
import InfoCircle from '../../Icons/outline/InfoCircle';

interface Props {
  title: string;
  tooltipContent: string;
  items: {
    value?: string;
    description?: string;
    hasFeature?: boolean;
  }[];
  showFourthColumn?: boolean;
}
const maxItemsToShow = 3;

const ComparePlansRow: FC<Props> = ({ title, tooltipContent, items, showFourthColumn, ...props }) => {
  const [itemsToShow, setItemsToShow] = useState([]);
  useEffect(() => {
    if (items?.length > 0) {
      const columnCount = showFourthColumn ? maxItemsToShow : maxItemsToShow - 1;
      const defaultLegend = items[0].description;
      const mappedItems = [];
      for (let i = 0; i < columnCount; i++) {
        if (items[i]) {
          mappedItems.push(items[i]);
        } else {
          if (defaultLegend) {
            mappedItems.push({ value: '--', description: defaultLegend });
          } else {
            mappedItems.push({ hasFeature: false });
          }
        }
      }
      setItemsToShow(mappedItems);
    }
  }, [items, showFourthColumn]);

  return (
    <ComparePlansRowStyled {...props}>
      <div className="cp-row__wrapper">
        <div className="cp-row__header">
          <span>{title}</span>
          {tooltipContent && (
            <Tooltip tabIndex={0} theme="light" interactive={true} html={<span>{tooltipContent}</span>}>
              <InfoCircle />
            </Tooltip>
          )}
        </div>
        <div className="cp-row__content">
          {itemsToShow.map((item, index) => (
            <div className="cp-row__item" key={`plan_${index}__feature`}>
              {item.description ? (
                <>
                  <div className="cp-row__item-title">
                    <span>{item.value}</span>
                  </div>
                  <div className="cp-row__item-description">
                    <span>{item.description}</span>
                  </div>
                </>
              ) : (
                <div className="cp-row__item-icon">{item.hasFeature ? <Check /> : <Minus />}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </ComparePlansRowStyled>
  );
};

ComparePlansRow.displayName = 'ComparePlansRow';

export default ComparePlansRow;
